import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Rotas protegidas (blueprint 13): sem sessao -> redireciona para /entrar.
export function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div data-testid="auth-loading" style={{ padding: 24 }}>
        Verificando sessão…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/entrar" replace />;
  }
  return children;
}
